export function HomepageImageBlock4() {
  return (
    <a href="">
      <img
        className="project-image"
        // id="project-homepagee"
        src="/images/arc-thurrock-homep.webp"
        alt="Preview of my latest project"
      />
    </a>
  );
}
